import { AccountHeader, AccountSection, Alert } from "../Account.styled";
import AccountFormLayout from "./account-form";
import { AccountType, AccountVerify } from "@providers/profile/ProfileProvider.model";

export interface AccountInformationProps {
  user: AccountVerify;
  isDigital: boolean;
}

const AccountInformation = ({ user, isDigital }: AccountInformationProps) => {
  return (
    <AccountSection>
      <AccountHeader>
        <h3 data-testid="account-information">Account Information</h3>
      </AccountHeader>
      {user?.account_type === AccountType.CHILD && (
        <Alert data-testid="account-child-alert">
          Please contact the account owner of your subscription to update subscription and billing
          information
        </Alert>
      )}
      <AccountFormLayout isDigital={isDigital} />
    </AccountSection>
  );
};

export default AccountInformation;
